<template>
    <el-card class="detailed">
      <!-- 头部面包屑 -->
        <el-breadcrumb class="detailed-breadcrumb" separator="/">
          <el-breadcrumb-item to="test-center">
            <span class="detailed-color" >测评中心</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item class="detailed-color">
            <span class="detailed-color" @click="$router.go(-1)">
             班级对比报告</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>知识点明细</el-breadcrumb-item>
        </el-breadcrumb>
      <!-- 知识点标题 -->
        <div class="detailed-title">
          <span class="detailed-title__line"></span>
          <div class="detailed-title__left" id="box">
            {{requestCondition.tag_name}}
          </div>
          <div id="detailed-box"></div>
          <el-button
          class="detailed-title__button"
          icon="el-icon-video-play"
          @click="showAnalysis">知识点视频讲义</el-button>
          <div class="clear"></div>
        </div>
      <!-- 平均 掌握程度 -->
        <div class="detailed-grasp">
          <span class="detailed-grasp__number">01</span>
          <div class="detailed-grasp__title">
            {{requestCondition.tag_name}}
          </div>
          <MasteryDegree class="detailed-grasp__md"
          :overallMastery="overallMastery"/>
        </div>
        <div class="detailed-insulate"></div>
      <!-- 此知识点学生掌握明细 -->
        <div class="detailed-public">
          <span class="detailed-public__two">02</span>
          <div class="detailed-public__title">此知识点学生掌握明细</div>
          <sort
            @showAnalysis="showAnalysis"
            class="detailed-public__main"
            :masterList="masterList"
            :row="row"
            :requestCondition="requestCondition"
            :unMasterList="unMasterList"
            />
        </div>
        <div class="detailed-insulate"></div>
      <!-- 知识点错题关联 -->
        <div class="detailed-public">
          <span class="detailed-public__two">03</span>
          <div class="detailed-public__title">知识点关联错题</div>
         <el-tooltip
            class="item"
            effect="dark"
            content="请勾选需要布置的题目"
            placement="top"
            v-if="topic.length < 1"
          >
            <el-button type="primary"
              class="detailed-public__button"
              :class="{color: topic.length === 0}"
              icon="el-icon-plus"
              @click="handleAssign(0)"
              >布置错题巩固练习</el-button>
          </el-tooltip>
          <el-button type="primary"
              v-else
              class="detailed-public__button"
              :class="{color: topic.length === 0}"
              icon="el-icon-plus"
              @click="handleAssign(0)"
              >布置错题巩固练习</el-button>
          <el-button
          v-show="topic.length > 0"
          class="detailed-public__button"
          @click="handleAssign"
          >取消</el-button>
          <Correlation
            ref="correlate"
            @multipleSelection="multipleSelection"
            :knowledgeWrongList = "knowledgeWrongList"
            class="detailed-public__correlation"/>
        </div>
        <!-- 视屏讲义弹框 -->
        <DetailedDialog
        :isShow.sync="isShow"
        :basicUrl="basicUrl"
        :consolidateUrl="consolidateUrl"
        :handout="handout"
        />
        <!-- 布置错题巩固弹框 -->
        <AssignMistakes
         :isAssignShow.sync="isAssignShow"
         :topic='topic'
         :row="row"
         :requestCondition="requestCondition"
         @clearchange="clearchange"
        />
    </el-card>
</template>

<script>
import MasteryDegree from '@/components/mastery-degree.vue';
import Sort from '@/components/sort.vue';
import Correlation from '@/components/correlation.vue';
import { knowledgeWrong, knowledgeDetail } from '@/api/pt';
import storeCreator from '@/utils/store-creator';
import DetailedDialog from './components/detailed-dialog.vue';
import AssignMistakes from './components/assign-mistakes.vue';

export default {
  name: 'detailed',
  components: {
    MasteryDegree,
    Sort,
    Correlation,
    DetailedDialog,
    AssignMistakes,
  },
  data() {
    return {
      isShow: false, // 视屏讲义弹框
      isAssignShow: false,
      topic: [],
      overallMastery: [], // 掌握进度
      handout: '', // 讲义
      basicUrl: '', // 知识点视屏
      consolidateUrl: '',
      masterList: [], // 掌握人
      unMasterList: [], // 未掌握人
      // type: true,
      knowledgeWrongList: [],
      row: [],
      requestCondition: {},
      // classId: '', // 班级Id
      // testName: '', // 测试名称
      // testId: '', // 测试课程Id
      // evaluateId: '', // 测评id
      // subjectId: '', // 学科id
      // className: '',
    };
  },
  created() {
    const store = storeCreator.create('pt');
    this.row = JSON.parse(store.get('row'));
    this.requestCondition = {
      ...this.$route.query,
      isKnowledge: 1,
    };
  },
  mounted() {
    this.bgWidth();
    this.knowledgeWrong();
    this.knowledgeDetail();
  },
  // created() {
  //   this.knowledgeDetail();
  // },
  methods: {
    bgWidth() {
      document.getElementById('detailed-box').style.width = `${document.getElementById('box').offsetWidth}px`;
    },
    showAnalysis() {
      this.isShow = true;
    },
    multipleSelection(val) { // 将选中的题目复制给父组件
      this.topic = val;
    },
    handleAssign(type) {
      if (type) {
        this.$confirm('是否取消布置,取消后不会保留所选内容', {
          customClass: 'message-logout',
          confirmButtonText: '取消布置',
          cancelButtonText: '继续布置',
        })
          .then(() => {
            this.$refs.correlate.clearchange();
          })
          .catch(() => {});
        return;
      }
      if (this.topic.length <= 0) {
        return;
      }
      let flag = true;
      if (flag) {
        this.isAssignShow = true;
        flag = false;
      }
    },
    clearchange() { // 清空选择
      this.$refs.correlate.clearchange();
    },
    knowledgeWrong() { // 错题请求
      knowledgeWrong({
        tag_code: this.requestCondition.tag_code,
        type: this.requestCondition.classType,
        batch_id: this.requestCondition.batchId,
        subject_id: this.requestCondition.subjectId,
        evaluate_id: this.requestCondition.evaluateId, // 测评id
        class_id: this.requestCondition.classId,
      }).then(({ data }) => {
        this.knowledgeWrongList = data;
      });
    },
    knowledgeDetail() { // 明细请求
      knowledgeDetail({
        tag_code: this.requestCondition.tag_code,
        type: this.requestCondition.classType,
        batch_id: this.requestCondition.batchId,
        subject_id: this.requestCondition.subjectId,
        evaluate_id: this.requestCondition.evaluateId,
        class_id: this.requestCondition.classId,
      }).then((res) => {
        if (res.code === 200) {
          this.overallMastery = [res.data.overall_mastery];
          this.basicUrl = res.data.basic_video_url;
          this.consolidateUrl = res.data.consolidate_video_url;
          this.masterList = res.data.master_list;
          this.unMasterList = res.data.un_master_list;
          this.handout = res.data.handout;
          console.log('masterList-------new', this.masterList, this.masterList.sort((a, b) => b.code_ability - a.code_ability));
          console.log('unMasterList-------new', this.unMasterList, this.unMasterList.sort((a, b) => b.code_ability - a.code_ability));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card /deep/ .el-card__body {
    padding: 0px;
  }
  .clear {
    clear: both;
    }
    .color {
      background-color: rgba(17, 31, 44, 0.12);
      border-color: rgba(17, 31, 44, 0.12);
    }
  .detailed {
    font-family: 'PingFangSC-Regular', 'PingFang SC';
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px;
    &-insulate {
      border-bottom: 1px solid #F3F6FD;
    }
    &-breadcrumb {
      height: 14px;
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
    }
    &-color {
      color: #1989FA;
      cursor: pointer;
    }
    &-title {
      margin-top: 23px;
      margin-bottom: 50px;
      #detailed-box {
        // width: 129px;
        position: relative;
        height: 13px;
        top: 8px;
        left: 10px;
        background: rgba(230, 162, 60, 0.2);
        border-radius: 7px;
      }
      &__left {
        float: left;
        font-size: 18px;
        height: 25px;
        font-weight: 500;
        color: #000000;
        line-height: 25px;
      }
      &__line {
        float: left;
        margin-top: 5px;
        margin-right: 8px;
        width: 3px;
        height: 16px;
        background: #1890FF;
        border-radius: 3px;
      }
      &__button {
        float: right;
        width: 160px;
        height: 40px;
        margin-right: 21px;
        margin-top: -15px;
        color: #fff;
        background: #FFA82D;
        border-radius: 4px;
      }
    }
    &-grasp {
      height: 250px;
      position: relative;
      &__number {
        float: left;
        padding: 0 9px;
        height: 29px;
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        text-align: center;
        line-height: 29px;
        background: url('./images/class_bg.png') no-repeat;
      }
      &__title {
        float: left;
        margin-top: 2px;
        margin-left: 9px;
        height: 24px;
        font-size: 18px;
        font-weight: 500;
        color: #000000;
        line-height: 24px;
      }
      &__md {
        position: absolute;
        top: 65px;
      }
    }
    &-public {
      padding-top: 40px;
      // height: 482px;
      margin-bottom: 40px;
      &__two {
        float: left;
        padding: 0 9px;
        height: 29px;
        font-size: 17px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        text-align: center;
        line-height: 29px;
        background: url('./images/class_bg.png') no-repeat;
      }
      &__title {
        float: left;
        margin-top: 2px;
        margin-left: 9px;
        height: 24px;
        font-size: 18px;
        font-weight: 500;
        color: #000000;
        line-height: 24px;
      }
      &__button {
        float: right;
        width: 170px;
        height: 40px;
        margin-right: 20px;
      }
      &__main {
        margin-top: 60px;
      }
      &__correlation {
        margin-top: 60px;
      }
    }
  }
</style>
